<template>
  <div style="height: 100%">
    <!--电子地图-->
    <label style="margin-top: 15px;font-weight: bold;margin-left: 30px;">电子地图</label>
    <!--    <map-chart :data="data" ref="mapChart" style="height: 100%;margin-top: -10%;"></map-chart>-->
    <brick-map-chart :data="data" @spaceChoose="spaceClick" ref="mapChart"
                     style="height: 100%;margin-top: -7%;"></brick-map-chart>
  </div>
</template>

<script>
import {getProvinceSpace} from "@/network/space-info";
import BrickMapChart from "@/components/echarts/BrickMapChart";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "Map",
  mixins: [platenLayoutEdit],
  components: {
    BrickMapChart
  },
  data() {
    return {
      data: []
    }
  },
  created() {
    this.getData();
    this.$store.dispatch('addIntervalObj', {'getMapData:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getMapData')
  },
  methods: {
    getData() {
      getProvinceSpace().then(res => {
        if (res.code === 0) {
          this.data = res.data
        }
      })
    },
    spaceClick(data) {
      if (this.isPlatenLayoutEditing) return
      console.log(data);
      // let routeUrl = this.$router.resolve({
      //   path: "/overview",
      //   query: {spaceId: data.id, spaceName: data.title}
      // });
      // window.open(routeUrl.href, '_blank')
      this.$router.push({
        path: "/overview",
        query: {spaceId: data.id, spaceName: data.title}
      })
    }
  }
}
</script>

<style scoped>

</style>
